import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { setLoderStatus } from "../../actions/SecurePaymentActions";
import {
  loadPiParityDetails,
  loadSppPaymentEventsDetails,
  setTermsConditionAccepted,
} from "../../actions/UserInfoActions";
import SecurePaymentService from "../../services/SecurePaymentService";
import LoggerService from "../../services/LoggerService";
import store from "../../stores/store";
import { setAdobeAnalyticsDataForEventTracking } from "../../services/analytics-util";
import {
  getPaymentMiniAppLogDto,
  getCommonSplunkDtoForPaymentMiniApp,
  clampIframeHeightPx,
  clampIframeWidthPx,
  DEFAULT_IFRAME_HEIGHT_PX,
  mapEventToTracking,
  normalizePiParityLogMetadata,
  openExternalUrlFromOpenUrlEvent,
  PAYMENT_MINI_APP_EVENTS,
  PAYMENT_MINI_APP_SPLUNK_EVENT_POSTMESSAGE_INVALID_PAYLOAD,
  PAYMENT_MINI_APP_SPLUNK_EVENT_POSTMESSAGE_PARSE_FAILURE,
} from "../../utils/payment-mini-app-utils";

class PaymentMiniApp extends Component {
  constructor(props) {
    super(props);
    this.handleIframeLoad = this.handleIframeLoad.bind(this);
    this.handleIframeError = this.handleIframeError.bind(this);
    this.handleFrameTasks = this.handleFrameTasks.bind(this);
    this.logPiParityEvents = this.logPiParityEvents.bind(this);
    this._payLinkInitSent = false;
    this._payLinkSrcSnapshot = "";
    this.state = {
      userDetails: props.userDetailsForTokenizer || {},
      iframeHeightPx: DEFAULT_IFRAME_HEIGHT_PX,
      iframeWidthPx: null,
    };
    this.props.setLoderStatus(true);
  }

  splunkReferenceFields() {
    return getPaymentMiniAppLogDto({
      payLinkOrderId: this.props.payLinkOrderId,
      userInfo: this.props.userInfo,
      userDetails: this.state.userDetails,
    });
  }

  async logPiParityEvents(eventType, metadata = {}) {
    await SecurePaymentService.logPiParityEvents(
      eventType,
      normalizePiParityLogMetadata(metadata, this.props.payLinkOrderId || undefined),
    );

    const eventTypeStr = String(eventType || "").trim();
    if (!eventTypeStr) {
      return;
    }

    const pi = this.props.piParityApp || {};
    const agentLdap =
      pi.createdby != null ? String(pi.createdby).trim() : "";

    const ui = this.props.userInfo || {};
    const ud = this.state.userDetails || {};
    const sppEnvelope =
      store.getState().UserInfoReducer.sppPaymentEventsMessage ||
      this.props.sppPaymentEventsMessage;
    const secondaryBusinessIdRaw =
      sppEnvelope &&
      sppEnvelope.secondarybusinessid != null &&
      String(sppEnvelope.secondarybusinessid).trim() !== ""
        ? String(sppEnvelope.secondarybusinessid).trim()
        : "";
    const orderNumber =
      secondaryBusinessIdRaw ||
      String(this.props.payLinkOrderId || "").trim();
    const analysticsObj = {
      agentLdap,
      customerGuid: _.has(ui, "authId") ? ui.authId : "",
      customerEmail: ud.email || ui.email || "",
      customerCountryCode: ud.countryCode || ui.countryCode || "",
      flowType: "SecurePaymentPortal",
      featureName: "PaymentMiniApp",
      subFeatureName: eventTypeStr,
      orderNumber,
    };
    setAdobeAnalyticsDataForEventTracking(analysticsObj);
  }

  componentDidMount() {
    window.addEventListener("message", this.handleFrameTasks);
    this.syncLoaderWithCommerceWalletUrl();
    this.props.setTermsConditionAccepted(false);
  }

  componentDidUpdate(prevProps) {
    const prevUrl =
      prevProps.applicationConfig &&
      prevProps.applicationConfig.commerce_wallet_url;
    const nextUrl =
      this.props.applicationConfig &&
      this.props.applicationConfig.commerce_wallet_url;
    if (prevUrl !== nextUrl) {
      this.syncLoaderWithCommerceWalletUrl();
    }
    if (
      prevProps.userDetailsForTokenizer !== this.props.userDetailsForTokenizer
    ) {
      this.setState({
        userDetails: this.props.userDetailsForTokenizer || {},
      });
    }

    const srcNow = this.payLinkSrc();
    if (this._payLinkSrcSnapshot && this._payLinkSrcSnapshot !== srcNow) {
      this.setState({
        iframeHeightPx: DEFAULT_IFRAME_HEIGHT_PX,
        iframeWidthPx: null,
      });
    }
    this._payLinkSrcSnapshot = srcNow || "";
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleFrameTasks);
  }

  syncLoaderWithCommerceWalletUrl() {
    const base =
      this.props.applicationConfig &&
      this.props.applicationConfig.commerce_wallet_url;
    if (!base) {
      this.props.setLoderStatus(false);
    } else {
      this.props.setLoderStatus(true);
    }
  }

  getCommerceOrigin() {
    const base =
      this.props.applicationConfig &&
      this.props.applicationConfig.commerce_wallet_url;
    if (!base) {
      return "";
    }
    try {
      return new URL(base).origin;
    } catch (e) {
      return "";
    }
  }

  sendToFrame(data) {
    const iframe = document.querySelector("#payment-mini-app-iframe");
    const target = this.getCommerceOrigin();
    if (!iframe || !iframe.contentWindow || !target) {
      return;
    }
    iframe.contentWindow.postMessage(data, target);
  }

  async initializePayLink() {
    let piResponse = this.props.piParityApp;
    if (!piResponse || Object.keys(piResponse).length === 0) {
      try {
        piResponse = await this.props.loadPiParityDetails();
      } catch (err) {
        console.log(err);
        piResponse = {};
      }
    }
    let piParity = {};
    if (
      piResponse &&
      piResponse.message &&
      typeof piResponse.message === "object"
    ) {
      piParity = piResponse.message;
    }

    if (this.props.sppPaymentEventsMessage == null) {
      try {
        await this.props.loadSppPaymentEventsDetails(
          String(this.props.payLinkOrderId || "").trim() || undefined,
        );
      } catch (err) {
        console.log(err);
      }
    }

    const ud = this.state.userDetails || {};
    const street1 = _.has(ud, "userAddress.address")
      ? String(ud.userAddress.address).trim()
      : "";
    const city = _.has(ud, "userAddress.city")
      ? String(ud.userAddress.city).trim()
      : "";
    const stateCode = _.has(ud, "userAddress.state")
      ? String(ud.userAddress.state).trim()
      : "";
    const postalCode = _.has(ud, "userAddress.postalCode")
      ? String(ud.userAddress.postalCode).trim()
      : "";
    const email =
      ud.email || (this.props.userInfo && this.props.userInfo.email) || "";
    const payload = {
      app: "pay-link",
      type: "System",
      subType: "InitializePayLink",
      data: {
        email,
        orderId: this.props.payLinkOrderId || "",
        authId: _.has(this.props, "userInfo.authId")
          ? this.props.userInfo.authId
          : "",
        formFieldData: {
          firstName: _.has(ud, "first_name") ? ud.first_name : "",
          lastName: _.has(ud, "last_name") ? ud.last_name : "",
          street1,
          city,
          stateCode,
          postalCode,
          phoneNumber: _.has(ud, "phoneNumber") ? ud.phoneNumber : "",
        },
        piParity,
      },
    };
    this.sendToFrame(payload);
  }

  tryInitializePayLink() {
    if (this._payLinkInitSent) {
      return;
    }
    this._payLinkInitSent = true;
    this.initializePayLink().catch((err) => console.log(err));
  }

  logMappedIframeTracking(eventData) {
    mapEventToTracking(eventData).forEach(({ eventType, meta }) => {
      this.logPiParityEvents(eventType, { ...meta });
    });
  }

  handleFrameTasks(e) {
    const TRUSTED_COMMERCE_ORIGIN = this.getCommerceOrigin();
    if (!TRUSTED_COMMERCE_ORIGIN || e.origin !== TRUSTED_COMMERCE_ORIGIN) {
      return;
    }
    let eventData = {};
    try {
      eventData = typeof e.data === "object" ? e.data : JSON.parse(e.data);
    } catch {
      const dto = this.splunkReferenceFields();
      const messageObject = {
        ...getCommonSplunkDtoForPaymentMiniApp(dto),
        Message: "Payment mini app iframe message could not be parsed",
        Flow: "Iframe PostMessage Parse Failure",
        eventType: PAYMENT_MINI_APP_SPLUNK_EVENT_POSTMESSAGE_PARSE_FAILURE,
        Result: "Failure",
      };
      LoggerService.saveSplunkLog(messageObject, "error");
      return;
    }
    if (!eventData || typeof eventData !== "object") {
      const dto = this.splunkReferenceFields();
      const messageObject = {
        ...getCommonSplunkDtoForPaymentMiniApp(dto),
        Message: "Payment mini app iframe message was not an object",
        Flow: "Iframe PostMessage Invalid Payload",
        eventType: PAYMENT_MINI_APP_SPLUNK_EVENT_POSTMESSAGE_INVALID_PAYLOAD,
        Result: "Failure",
      };
      LoggerService.saveSplunkLog(messageObject, "error");
      return;
    }
    console.log("eventDetails from Iframe", eventData);
    // commerce-core posts an object for OpenURL RETURN_BACK (SUSI return URL).
    const msg = eventData;
    if (msg.type === "OpenURL" && msg.subType === "RETURN_BACK") {
      const d = msg.data && typeof msg.data === "object" ? msg.data : {};
      const rawUrl = d.externalUrl;
      if (typeof rawUrl === "string") {
        const trimmed = rawUrl.trim();
        if (trimmed) {
          try {
            const url = new URL(trimmed);
            if (url.protocol && window.top) {
              window.top.location.href = url.href;
              return;
            }
          } catch {
            /* invalid URL — ignore */
          }
        }
      }
      return;
    }
    const isOpenUrlExternal =
      eventData.type === "OpenURL" && eventData.subType === "EXTERNAL";
    if (isOpenUrlExternal) {
      openExternalUrlFromOpenUrlEvent(eventData);
    }
    if (eventData?.subType !== "Resize" && !isOpenUrlExternal) {
      this.logMappedIframeTracking(eventData);
      const primary = mapEventToTracking(eventData)[0];
      if (primary && String(primary.eventType || "").trim()) {
        const isBusinessFailure =
          primary.eventType === PAYMENT_MINI_APP_EVENTS.PAYMENT_FAILURE;
        const errorCode =
          isBusinessFailure &&
          primary.meta &&
          primary.meta.errorCode != null &&
          primary.meta.errorCode !== ""
            ? String(primary.meta.errorCode)
            : "";
        const dto = this.splunkReferenceFields();
        const messageObject = {
          ...getCommonSplunkDtoForPaymentMiniApp(dto),
          Message: isBusinessFailure
            ? "Payment mini app reported payment failure"
            : "Payment mini app iframe event processed",
          Flow: isBusinessFailure
            ? "Iframe PostMessage Payment Failure"
            : "Iframe PostMessage Event",
          eventType: primary.eventType,
          ...(errorCode ? { errorCode } : {}),
          Result: isBusinessFailure ? "Failure" : "Success",
        };
        LoggerService.saveSplunkLog(
          messageObject,
          isBusinessFailure ? "error" : "info",
        );
      }
    }
    switch (eventData.subType) {
      case "AppLoaded":
        this.props.setLoderStatus(false);
        // Re-send init once the iframe app confirms it is ready.
        this._payLinkInitSent = false;
        this.tryInitializePayLink();
        break;
      case "Resize":
        if (eventData.type === "System") {
          const data =
            eventData.data && typeof eventData.data === "object"
              ? eventData.data
              : {};
          const heightPx = clampIframeHeightPx(data.height);
          const widthPx = clampIframeWidthPx(data.width);
          const next = {};
          if (heightPx !== null) {
            next.iframeHeightPx = heightPx;
          }
          if (widthPx !== null) {
            next.iframeWidthPx = widthPx;
          }
          if (Object.keys(next).length) {
            this.setState(next);
          }
        }
        break;
      default:
        break;
    }
  }

  handleIframeLoad() {
    const dto = this.splunkReferenceFields();
    const messageObject = {
      ...getCommonSplunkDtoForPaymentMiniApp(dto),
      Message: "Payment mini app iframe loaded successfully",
      Flow: "Iframe Load Success",
      Result: "Success",
    };
    LoggerService.saveSplunkLog(messageObject, "info");
    this.props.setLoderStatus(false);
    this.tryInitializePayLink();
  }

  handleIframeError() {
    const dto = this.splunkReferenceFields();
    const messageObject = {
      ...getCommonSplunkDtoForPaymentMiniApp(dto),
      Message: "Payment mini app iframe failed to load",
      Flow: "Iframe Load Failure",
      Result: "Failure",
    };
    LoggerService.saveSplunkLog(messageObject, "error");
    this.props.setLoderStatus(false);
  }

  payLinkSrc() {
    const base =
      this.props.applicationConfig &&
      this.props.applicationConfig.commerce_wallet_url;
    if (!base) {
      return "";
    }
    const lang = this.props.localeLanguageCode || "en";
    const orderId = this.props.payLinkOrderId || "";
    const q = new URLSearchParams({
      lang,
      af: "reba_enable_pay_link",
      orderId,
      ss: "pay-link",
    });
    const ud = this.state.userDetails || {};
    if (ud.countryCode) {
      q.set("countryCode", ud.countryCode);
    }
    q.set("ctx", "if");
    q.set("cli", "hendrix");
    if (typeof window !== "undefined" && window.location) {
      q.set("ctxRtUrl", window.location.href);
    }
    return `${base.replace(/\/$/, "")}/billing/pay-link?${q.toString()}`;
  }

  render() {
    const src = this.payLinkSrc();
    const iframeHeight = this.state.iframeHeightPx;
    const iframeWidth = this.state.iframeWidthPx;
    return (
      <div className="payment-mini-app-outer">
        <div className="align-center">
          {src ? (
            <iframe
              data-testid="payment-mini-app-iframe"
              id="payment-mini-app-iframe"
              title="payment mini app"
              src={src}
              onLoad={this.handleIframeLoad}
              onError={this.handleIframeError}
              style={{
                width: iframeWidth != null ? `${iframeWidth}px` : "100%",
                border: "none",
                height: `${iframeHeight}px`,
                overflow: "hidden",
                display: "block",
              }}
              allow="payment"
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  applicationConfig: state.AppReducer.applicationConfig,
  localeLanguageCode: state.LocaleReducer.languageCode,
  userInfo: state.AuthReducer.userInfo,
  piParityApp: state.UserInfoReducer.piParityApp,
  sppPaymentEventsMessage: state.UserInfoReducer.sppPaymentEventsMessage,
});

const mapDispatchToProps = (dispatch) => ({
  setLoderStatus: (flag) => dispatch(setLoderStatus(flag)),
  setTermsConditionAccepted: (val) => dispatch(setTermsConditionAccepted(val)),
  loadPiParityDetails: () => dispatch(loadPiParityDetails()),
  loadSppPaymentEventsDetails: (orderId) =>
    dispatch(loadSppPaymentEventsDetails(orderId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(PaymentMiniApp));
